/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The state of the prize draw
 */
export type PrizeDrawStatus =
  (typeof PrizeDrawStatus)[keyof typeof PrizeDrawStatus]

export const PrizeDrawStatus = {
  DRAFT: "DRAFT",
  OPEN: "OPEN",
  ENTRY_CLOSED: "ENTRY_CLOSED",
  CALCULATING_WINNERS: "CALCULATING_WINNERS",
  WINNERS_CALCULATED: "WINNERS_CALCULATED",
  COMPLETED: "COMPLETED",
  WINNERS_PUBLISHED: "WINNERS_PUBLISHED",
  WINNERS_NOTIFIED: "WINNERS_NOTIFIED",
  UNKNOWN: "UNKNOWN",
} as const
